import type { FAQItem } from './types';

export const documentsFAQs: FAQItem[] = [
  {
    id: 'document-vault-details',
    question: 'How is the document vault designed to keep things organized and secure?',
    answer: `The document vault is a planned feature, not live in the product today. The design intent:

• Role-based access (board, manager, resident)
• Version control with change history
• Full-text search on titles and tags
• Folder organization by category (bylaws, minutes, budgets)
• Expiration reminders for time-sensitive docs (licenses, insurance)

Residents would see only what they should; board would see everything, once built.`,
    category: 'documents',
  },
  {
    id: 'meeting-minutes-distribution',
    question: 'What would the workflow be for meeting minutes and approvals?',
    answer: `This describes the intended flow for a feature that is not built yet:

1. Secretary uploads draft minutes to the vault
2. Board members review and suggest corrections
3. Final version is approved and published to residents
4. Minutes are stored with a timestamp

This depends on the document vault described above, which does not persist data in the live product today.`,
    category: 'documents',
  },
  {
    id: 'document-retention',
    question: 'Will we be able to configure document retention and legal holds?',
    answer: `Retention and legal holds are planned, not built. The design intent is for admins to:

• Configure retention windows per category (e.g., invoices, minutes)
• Apply **legal holds** to prevent deletion during disputes
• Track version history with timestamps
• Export archives for auditors on request

This depends on the document vault, which is not yet built. Ask us for current status before relying on retention or legal-hold behavior for compliance.`,
    category: 'documents',
  },
  {
    id: 'storage-limits',
    question: 'How much storage will be included?',
    answer: `Document storage with tiered allocations is planned but not metered or enforced in the platform today. Tier-based storage limits and any additional-storage fee would be defined once storage metering is built. Ask us for current status before planning around specific allocations.`,
    category: 'documents',
  },
];
